import { withStyles } from '@material-ui/core';
import Viewer, { defaultLayout, Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import XAPPButton from '../Button/XAPPButton';

const styles = (theme) => ({
    root: {}
});

class PDFReaderDialog extends XAPPComponent {

    renderToolbar = (toolbarSlot) => {
        return (
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexGrow: 1,
                        flexShrink: 1,
                        justifyContent: 'center',
                    }}
                >
                    <div className={'viewer-toolbar-item'}>
                        {toolbarSlot.printButton}
                    </div>
                    <div className="flex-1" />
                    <div className={'viewer-toolbar-item'}>
                        <XAPPButton
                            type="Icon"
                            className="py-8 px-12"
                            onClick={() => this.props.openDialog()}
                            icon={"close"}
                            iconProps="text-black"
                        />
                    </div>
                </div>
            </div>
        );
    };

    layout = (isSidebarOpened, container, main, toolbar, sidebar,) => {
        return defaultLayout(
            isSidebarOpened,
            container,
            main,
            toolbar(this.renderToolbar),
            sidebar,
        );
    };

    render() {
        const { open, openDialog, url } = this.props;

        return (
            <React.Fragment>
                <XAPPDialog
                    id="PDFRender"
                    open={open}
                    onClose={() => openDialog()}
                    fullWidth
                    fullScreen
                    className="previewModal"
                >
                    <div style={{ overflow: 'auto' }}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.8.335/build/pdf.worker.min.js" target="_blank" without rel="noopener noreferrer">
                            <Viewer
                                fileUrl={url}
                                layout={this.layout}
                            />
                        </Worker>
                    </div>
                </XAPPDialog>
            </React.Fragment>
        )
    };
}


export default withStyles(styles, { withTheme: true })(PDFReaderDialog);
